<template>
  <div class="recommend-list">
    <template v-if="showTitle">
      <h3 class="title">You May Also Like</h3>
    </template>
    <div
      class="box"
      v-if="likeData.length"
      v-infinite-scroll="load"
      :infinite-scroll-distance="infiniteScrollDistance"
    >
      <ProductCard
        v-for="(item, index) of likeData"
        class="cart-recommend-item"
        :key="item.id"
        :productData="item"
        :clickIndex="index"
        :myWishlist="myWishlist"
        :uuid="uuid"
        :showUnderlinePrice="showUnderlinePrice"
        :cardType="CARD_TYPE.SMALL_SIZE"
        :inErrorPage="inErrorPage"
        @exposure="handleExposure"
        @itemClick="handleItemClick"
        @tryOnShow="handleProductCardTryOnShow"
      />
    </div>
    <p v-if="isLoading && !noMore" class="upwarp-nodata">
      <i class="iconfont icon-jiazai"></i> loading...
    </p>
    <p v-if="noMore" class="upwarp-nodata">—— No More ——</p>
    <try-on
      v-model:show="openTryOn"
      :glassesData="glassesData"
      :product="tryProduct"
      :inErrorPage="inErrorPage"
    />
  </div>
</template>

<script>
import { mapActions } from 'pinia';

import { CARD_TYPE } from '@/components/public/product-card/constants';
import ProductCard from '@/components/public/product-card/ProductCard.vue';
import tryOn from '@/components/public/try-on/try-on.vue';
import { useStore } from '@/store';

export default {
  name: 'RecommendList',
  components: { ProductCard, tryOn },
  props: {
    groupId: {
      type: Number,
      required: true,
    },
    myWishlist: {
      type: Boolean,
      default: false,
    },
    productList: {
      type: Array,
      default() {
        return [];
      },
    },
    /* blog 文章的类别 bottom right */
    blogType: {
      type: String,
      default: 'bottom',
    },
    sdYouAlsoLikeMktExp: {
      type: Function,
      default() {
        return () => () => {};
      },
    },
    sdYouAlsoLikeMktClick: {
      type: Function,
      default() {
        return () => () => {};
      },
    },
    uuid: {
      type: String,
      default: () => '',
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
    showUnderlinePrice: {
      type: Boolean,
      default: true,
    },
    inErrorPage: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['wishSuccess', 'wishCancel', 'itemClick'],
  data() {
    return {
      likeData: [],
      page: 1,
      isLoading: false,
      noMore: false,
      infiniteScrollDistance: 500,
      showTitle: true,
      CARD_TYPE,
      openTryOn: false,
      glassesData: '',
      tryProduct: {},
    };
  },
  computed: {
    groupNameInfo() {
      const info = {
        6: 'frame_list',
        7: 'wish_list',
        8: 'search_result_list',
        9: `blog_${this.blogType}_list`,
        10: 'track_order_list',
        11: 'coupon_center_list',
      };
      return info;
    },
  },
  mounted() {
    if (this.groupId && !this.isHistory) {
      this.load();
    }
    this.setInfiniteScrollDistance();
    window.addEventListener('resize', this.setInfiniteScrollDistance);
    // if (this.productList.length) this.likeData = [...this.productList];
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setInfiniteScrollDistance);
  },
  methods: {
    ...mapActions(useStore, ['getRecommendData']),
    handleExposure({ product, index }) {
      this.sdYouAlsoLikeMktExp(product);
    },
    handleItemClick({ product, index }) {
      this.$emit('itemClick');
      this.sdYouAlsoLikeMktClick(product);
    },
    setInfiniteScrollDistance() {
      let infiniteScrollDistance = document.documentElement.clientHeight * 0.8;
      if (infiniteScrollDistance < 500) {
        infiniteScrollDistance = 500;
      }
      this.infiniteScrollDistance = infiniteScrollDistance;
    },
    async getRecommendGoodsList() {
      try {
        this.isLoading = true;
        const data = await this.getRecommendData({
          group_id: this.groupId,
          limit: 12,
          page: this.page,
        });
        if (data) {
          if (this.page === 1 && data?.frame_list?.list.length === 0) {
            this.showTitle = false;
          }
          if (this.likeData.length >= data?.frame_list?.total) {
            this.noMore = true;
          }
          this.likeData = [...this.likeData, ...(data?.frame_list?.list || [])];
          console.log('购物车推荐', this.likeData);
          this.page++;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    load() {
      console.log('load@', this.page);
      if (!this.isLoading && !this.noMore) {
        this.getRecommendGoodsList(this.page);
      }
    },
    getRecommendState() {
      return {
        likeData: this.likeData,
        page: this.page,
        isLoading: this.isLoading,
        noMore: this.noMore,
      };
    },
    setRecommendData(data) {
      this.likeData = data.likeData;
      this.page = data.page;
      this.isLoading = data.isLoading;
      this.noMore = data.noMore;
    },
    handleProductCardTryOnShow(item) {
      this.glassesData = item.tryon_image_url;
      this.openTryOn = true;
      this.tryProduct = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend-list {
  margin: 0 auto;
  padding-bottom: 32px;
  width: 1440px;
  min-height: 100vh;
  background: #ffffff;
  .title {
    padding-top: 60px;
    padding-bottom: 32px;
    line-height: 36px;
    text-align: center;
    font-size: 28px;
    font-family: $f-pb;
  }
  .box {
    display: grid;
    margin: 0 auto;
    grid-template-columns: repeat(4, 1fr);
    gap: 46px 16px;
  }
}
.upwarp-nodata,
.upwarp-nodata-more {
  padding: 40px 0;
  text-align: center;
  color: $origin;

  // iconfont 一直转动
  .iconfont {
    display: inline-block;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1536px) {
  .recommend-list {
    padding: 0 48px 32px;
    width: 100%;
    box-sizing: border-box;
  }
}

@media (max-width: 1439px) {
  .recommend-list {
    .box {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media (max-width: 1100px) {
  .recommend-list {
    .box {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 820px) {
  .recommend-list {
    padding: 0;
    width: 725px;
  }
}

@media (max-width: 781px) {
  .recommend-list {
    padding: 0 28px 32px;
    width: 100%;
  }
}
.cart-recommend-item {
  min-width: 0;
}
</style>
